// @ts-check
import React from 'react'
import MaskedInput from 'react-text-mask'
import { Label } from '../Label/Label'
import { Error } from '../Error/Error'
import { InfoIcon } from '../InfoIcon/InfoIcon'
import styles from '../InputText/style.css'
import { validateUTF8StringLength } from '../../utils/validateUTFStringLength'

/**
 * @param {{
 * value: string,
 * label: string,
 * mask: [],
 * onChange?: Function,
 * onBlur?: Function,
 * error: string,
 * disabled?: boolean,
 * required?: boolean,
 * valid: boolean,
 * name: string,
 * placeholder?: string,
 * guide?: boolean,
 * info?: string,
 * showLabelAsPlaceholder?: boolean,
 * blockClassName: string,
 * onKeyPress?: Function,
 * maxLength?: number }} props
 */
const InputMasked = ({
  value,
  label,
  mask,
  onChange,
  onBlur,
  error,
  disabled,
  required,
  valid,
  name,
  placeholder,
  guide,
  info,
  showLabelAsPlaceholder,
  blockClassName,
  onKeyPress,
  maxLength
}) => {
  /**
   * @type {string}
   */
  const htmlFor = label
  const className = error.length ? styles.inputInvalid : ''
  const onChangeHandler = (event) => {
    const { target: { value } } = event
    if (maxLength) {
      if (validateUTF8StringLength(value, maxLength)) {
        onChange(event)
      }
    } else {
      onChange(event)
    }
  }
  return (
    <div className={`${styles.field} ${blockClassName}`}>
      <div className={styles.inputBlock}>
        {!showLabelAsPlaceholder && (
          <Label htmlFor={htmlFor} value={label} valid={valid} info={info} />
        )}
        <MaskedInput
          mask={mask}
          id={htmlFor}
          name={name}
          placeholder={showLabelAsPlaceholder ? label : placeholder}
          className={`${styles.input} ${className}`}
          value={value}
          onChange={onChangeHandler}
          onBlur={onBlur}
          disabled={disabled}
          required={required}
          guide={guide}
          onKeyPress={onKeyPress}
          maxLength={maxLength}
        />
        <Error value={error} />
      </div>
      {showLabelAsPlaceholder && info && (
        <div className={styles.info}>
          <InfoIcon text={info} />
        </div>
      )}
    </div>
  )
}

InputMasked.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  disabled: false,
  required: false,
  guide: true,
  blockClassName: '',
  error: ''
}

export { InputMasked }
